import { render, staticRenderFns } from "./guia.vue?vue&type=template&id=34c5dda9&scoped=true"
import script from "./guia.vue?vue&type=script&lang=js"
export * from "./guia.vue?vue&type=script&lang=js"
import style0 from "./guia.vue?vue&type=style&index=0&id=34c5dda9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5dda9",
  null
  
)

export default component.exports